import actions from './auth.actions'
import reducer from './auth.reducer'
import { addReducer } from '_core'

addReducer('auth', reducer)

export { actions as auth }
export * from 'pages/LoginPage'
